/*
 * SonarQube
 * Copyright (C) 2009-2021 SonarSource SA
 * mailto:info AT sonarsource DOT com
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with this program; if not, write to the Free Software Foundation,
 * Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */
/*
 * The esbuild postcss plugin fails to handle CSS `@import`
 */
import './components/badges.css';
import './components/boxed-group.css';
import './components/columns.css';
import './components/component-name.css';
import './components/dropdowns.css';
import './components/global-loading.css';
import './components/issues.css';
import './components/list-groups.css';
import './components/menu.css';
import './components/page.css';
import './components/panels.css';
import './components/spinner.css';
import './components/ui.css';
import './init/base.css';
import './init/forms.css';
import './init/icons.css';
import './init/links.css';
import './init/lists.css';
import './init/misc.css';
import './init/tables.css';
import './init/type.css';
import './mixins.css';
import './print.css';
import './sonar-colorizer.css';
import './style.css';
